const actionTypes = {
  CLOSURE_RESET: 'CLOSURE_RESET',

  CLOSURE_DATA_FETCH: 'CLOSURE_DATA_FETCH',
  CLOSURE_DATA_SUCCESS: 'CLOSURE_DATA_SUCCESS',
  CLOSURE_DATA_ERROR: 'CLOSURE_DATA_ERROR',

  CLOSURE_POSTING_FETCH: 'CLOSURE_POSTING_FETCH',
  CLOSURE_POSTING_SUCCESS: 'CLOSURE_POSTING_SUCCESS',
  CLOSURE_POSTING_ERROR: 'CLOSURE_POSTING_ERROR',
};

export default actionTypes;
